import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import Pagination from '../../../components/DatatablePagination';

// Một component nhỏ để render checkbox, giúp code gọn gàng hơn
const CheckboxCell = ({ value }) => (
    <div style={{ textAlign: 'center' }}>
        <input 
            type="checkbox" 
            checked={value === true} // Chỉ check khi giá trị là true
            readOnly // Ngăn người dùng thay đổi trực tiếp
        />
    </div>
);

export default (props) => {
    // console.log(props);
    const [state, setState] = useState({
        columns: [],
    });

    useEffect(() => {
        setState({
            ...state,
            columns: [
                {
                    columns: [
                        {
                            Header: 'ID',
                            accessor: 'material_id',
                            minWidth: 150,
                        },
                        {
                            Header: 'Tên nguyên liệu',
                            accessor: 'name',
                            minWidth: 150,
                        },
                        {
                            Header: 'Đơn vị tính',
                            accessor: 'unit',
                        },
                        {
                            Header: 'Giá nhập',
                            accessor: 'price_new',
                        },
                        {
                            Header: 'Số lượng nhập',
                            accessor: 'count',
                        },
                        {
                            Header: 'Tồn kho',
                            accessor: 'inventory',
                        },
                        {
                            Header: 'Tổng số lượng đã nhập',
                            accessor: 'total',
                        },
                    ],
                },
            ],
        });
    }, []);

    return (
        <ReactTable
            defaultPageSize={10}
            data={props.data}
            columns={state.columns}
            minRows={0}
            showPageJump={false}
            showPageSizeOptions={true}
            PaginationComponent={Pagination}
            NoDataComponent={() => null}
        />
    );
};
